import React from "react";
import ApiConnect from "../../../Utils/ApiConnect";

export default function BarcodeScanner(props) {

  const handleBarcodeInput = async (e) => {
    if (e.key === "Enter") {
      const barcode = e.target.value.trim();
      if (barcode) {
        try {
          const response = await ApiConnect.get("/Module/Inventory/Product/Details?scanner=" + barcode);
          if (response.data && response.data.length === 1) {
            props.fallback(response.data[0]);
          }
        } catch (e) {
          console.error(e)
        }
        e.target.value = ""; // Clear the input field
      }
    }
  };

  return (
    <div className="input-group px-2">
      <input
        type="text"
        className="form-control border border-primary"
        placeholder="Barcode Scanner"
        onKeyDown={(e) => handleBarcodeInput(e)}
      />
      <div class="input-group-append">
        <span class="input-group-text">Barcode Scanner</span>
      </div>
    </div>
  );
}
